import React, { Component } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash.noop'
import SizePickerSelect from '../../containers/SizePickerSelect'

import * as Styled from './SelectSizePicker.styles'

class SelectSizePicker extends Component {
  render() {
    const { type, value, partNumber, combinations, selectPartNumber, sizeInfo, hasSizeChange } = this.props
    const showSelector = combinations?.length > 1
    return (
      <>
        <Styled.SizePickerHeader>
          <p data-test='select-size-picker-header'>
            <strong>
              {type}: {value}
            </strong>
          </p>
          {sizeInfo()}
        </Styled.SizePickerHeader>
        {hasSizeChange && showSelector && (
          <Styled.SizeAlert kind='info' isCloseable={false} data-test='select-size-alert'>
            Please check the sizes available in this colour:
          </Styled.SizeAlert>
        )}
        {showSelector && <SizePickerSelect {...{ type, partNumber, selectPartNumber, combinations }} />}
      </>
    )
  }
}

SelectSizePicker.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  partNumber: PropTypes.string.isRequired,
  combinations: PropTypes.array.isRequired,
  selectPartNumber: PropTypes.func.isRequired,
  sizeInfo: PropTypes.func,
  hasSizeChange: PropTypes.bool.isRequired
}

SelectSizePicker.defaultProps = {
  sizeInfo: noop
}

export default SelectSizePicker
